/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=PhoneHeader&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=PhoneHeader&lang=js"

import "./index.vue?vue&type=style&index=0&id=4417ee4f&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4417ee4f"]])

export default __exports__